import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { AddexpensepolicydetailsComponent } from '../addexpensepolicydetails/addexpensepolicydetails.component';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-addexpensepolicy',
  templateUrl: './addexpensepolicy.component.html',
  styleUrls: ['./addexpensepolicy.component.css']
})
export class AddexpensepolicyComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  formname: String = "ExpensePolicy";

  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;


  //Edit Get Values
  expensepolicyColl: any = [];
  expensepolicyBO: any = {};

  expensepolicyid: number = 0;

  expensepolicydetailsColl: any = [];





  expensepolicyform = new FormGroup({
    expensepolicyid: new FormControl(0),
    expensepolicyname: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });



  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe,
    private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.expensepolicyid = params.id
      }
    });

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.expensepolicyform.reset();
      this.fnInitializeFormGroup();

      if (this.expensepolicyid > 0) {
        this.fngetExpensePolicy();
      }


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.expensepolicyid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }
  fnInitializeFormGroup() {
    this.expensepolicyform.setValue({
      expensepolicyid: 0,
      expensepolicyname: '',
      inactive: false
    })
  }

  //Get 
  fngetExpensePolicy() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'expensepolicyid': this.expensepolicyid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getExpensepolicy(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.expensepolicyColl = res.json().result[0];
            var editdata = this.expensepolicyColl[0];
            this.fnEditMode(editdata);
            this.expensepolicyBO = editdata;

            this.expensepolicydetailsColl = res.json().result[1];

            console.log(res.json().result)
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.expensepolicyform.valid) {
        //Check
        this.saveloading = true;

        var data = {
          'expensepolicyid': this.expensepolicyid,
          'expensepolicyname': this.expensepolicyform.get('expensepolicyname').value,
          'inactive': this.expensepolicyform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'expensepolicydetailscoll': this.expensepolicydetailsColl
        }


        this.appService.fnCheckExpensepolicy(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.expensepolicyform.get('expensepolicyid').value > 0) {
                  //Update 
                  this.fnSetExpensePolicy(data);
                }
                else {
                  //Insert 
                  this.fnInsertExpensePolicy(data);
                }
              }
              else {
                if (_checkresult === "name") { this.saveloading = false;

                  this.expensepolicyform.controls['expensepolicyname'].setErrors({ 'notfound': true });
                }
              }
            }
            else { this.saveloading = false;

              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => { this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) { this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }




  //Insert
  fnInsertExpensePolicy(data) {

    this.appService.fnInsertExpensepolicy(data).subscribe(
      (res) => { this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new expensepolicy has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.expensepolicyname);

            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => { this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetExpensePolicy(data) {

    this.appService.fnSetExpensepolicy(data).subscribe(
      (res) => { this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The expensepolicy has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.expensepolicyid, data.expensepolicyname);

            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => { this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/ExpensePolicy']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }




  //Grid

  fnAddExpensepolicyDetails() {

    const modalRef = this.productFindService.open(AddexpensepolicydetailsComponent, { size: <any>'l' });

    modalRef.componentInstance.expensepolicydetailsColl = this.expensepolicydetailsColl;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      this.expensepolicydetailsColl.push(receivedEntry);
      
    });
    
  }

  fnEditExpensepolicyDetails(index) {


    const modalRef = this.productFindService.open(AddexpensepolicydetailsComponent, { size: <any>'l' });

    var data = this.expensepolicydetailsColl[index];

    modalRef.componentInstance.expensepolicydetid = data.expensepolicydetid;
    modalRef.componentInstance.expensetypeid = data.expensetypeid;
    modalRef.componentInstance.accuralperiod = data.accuralperiod;
    modalRef.componentInstance.amountlimit = data.amountlimit;
    modalRef.componentInstance.isallowoverlimit = data.isallowoverlimit;
    modalRef.componentInstance.expensepolicydetailsColl = this.expensepolicydetailsColl;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


      this.expensepolicydetailsColl[index].expensepolicydetid = receivedEntry.expensepolicydetid;
      this.expensepolicydetailsColl[index].expensetypeid = receivedEntry.expensetypeid;
      this.expensepolicydetailsColl[index].expensetypename = receivedEntry.expensetypename;
      this.expensepolicydetailsColl[index].amountlimit = receivedEntry.amountlimit;
      this.expensepolicydetailsColl[index].isallowoverlimit = receivedEntry.isallowoverlimit;
      this.expensepolicydetailsColl[index].accuralperiod = receivedEntry.accuralperiod;
     

    });

  }

  fnDeleteExpensepolicyConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete details?')
        .then((confirmed) => {
          if (confirmed) {
            this.expensepolicydetailsColl.splice(index, 1)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnDeleteExpensepolicyDetails(index) {



  }




  private fnEditMode(deptBO) {
    this.expensepolicyform.setValue({
      expensepolicyid: deptBO.expensepolicyid,
      expensepolicyname: deptBO.expensepolicyname,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
